export default "__VITE_ASSET__CUXb4BAu__"